import React, { useState, useEffect } from "react";
import { GET } from "../../services/AxiosService"; 

const Footer = () => {
  const [version, setVersion] = useState("");

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        const res = await GET(`/master-data/type?type=version_cms`);
        if (res?.data && res.data.length > 0) {
        const rawVersionString = res.data[0].name; 
          let formattedVersion = rawVersionString; 
          if (rawVersionString && rawVersionString.length === 5) {
            const major = rawVersionString.slice(0, 1); 
            const minor = rawVersionString.slice(1, 3); 
            const patch = rawVersionString.slice(3, 5); 
            formattedVersion = `${major}.${minor}.${patch}`;
          }
          setVersion(formattedVersion);
        }
      } catch (error) {
        console.error("Failed to fetch version:", error);
      }
    };

    fetchVersion();
  }, []); 

  return (
    <div className="footer">
      <div className="copyright">
        <p>
          {version && <span style={{ marginRight: "5px" }}>Version {version} | Copyright © {new Date().getFullYear()} Matahati</span>}

        
        </p>
      </div>
    </div>
  );
};

export default Footer;